<nav class="navbar navbar-expand-lg navbar-light fixed-top">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#conteudoNavbarSuportado" aria-controls="conteudoNavbarSuportado" aria-expanded="false" aria-label="Alterna navegação">
    <span class="navbar-toggler-icon"></span>
   </button>
 
   <div class="collapse navbar-collapse" id="conteudoNavbarSuportado">
        <ul class="navbar-nav mr-auto d-flex align-items-center">

            <li class="nav-item active">
           <!--definir imagem logo-->
            <img src="https://i.imgur.com/5KOEUob.png" alt="Logo Repassa" width ="80px" height="80px" class="img-fluid" routerLink='/home' >
           <!--/definir imagem logo-->
            </li>
        </ul>

        <ul class="navbar-nav ml-auto d-flex align-items-center">

            <!--Inicio-->
            <li class="nav-item active">
            <a routerLink="/home" class="p-3 colorFont selecao font-weight-bold">Início <span class="sr-only">(página atual)</span></a>
            </li>
            <!--/Inicio-->

            <!--SobreNós-->
            <li class="nav-item">
            <a class="p-3 colorFont selecao font-weight-bold"  routerLink='/sobre'>Sobre</a>
            </li>
            <!--/SobreNós-->

            <!--Cadastre-se-->
            <li class="nav-item">
            <a class="p-3 colorFont selecao font-weight-bold" routerLink='/cadastrar'>Cadastre-se</a>
            </li>
            <!--/Cadastre-se-->

            <!--BotãoEntrar-->
            <li class="nav-item">
            <button class="btn btn-sm btn-outline-warning" type="submit" routerLink='/logar'>Entrar <i class="fa fa-sign-in" aria-hidden="true"></i> </button>
            </li>
            <!--BotãoEntrar-->

        </ul>
    </div>
</nav>

